import React from 'react';
import { MessageSquare } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const FAQSection = () => (
  <section className="faq-section">
    <div className="section-container">
      <h2 className="section-headline">Common Questions About Switching</h2>
      <Accordion type="single" collapsible className="faq-accordion">
        <AccordionItem value="item-1">
          <AccordionTrigger>
            <div className="faq-question">
              <MessageSquare size={22} className="faq-icon" />
              <span>How long does switching take?</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="faq-answer">
              Most transitions are completed within 30 to 45 days. We handle the heavy lifting like data migration, benefits enrollment, and employee onboarding so you can focus on running your business. Our dedicated team coordinates directly with your current provider to ensure a smooth handoff.
            </div>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-2">
          <AccordionTrigger>
            <div className="faq-question">
              <MessageSquare size={22} className="faq-icon" />
              <span>What if we're mid-contract?</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="faq-answer">
              Most big box PEOs have a simple notice requirement, typically 30 to 60 days. We'll review your current contract terms during the consultation and help you understand your options. Many clients find the process is more straightforward than expected, and the savings with Amplify HR make the switch worthwhile. We'll walk through your specific situation with zero pressure.
            </div>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-3">
          <AccordionTrigger>
            <div className="faq-question">
              <MessageSquare size={22} className="faq-icon" />
              <span>Do you work with our industry?</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="faq-answer">
              Amplify HR serves businesses nationwide across manufacturing, professional services, healthcare, technology, retail, and more. Our service-first model adapts to your industry's unique needs. We don't force one-size-fits-all solutions. If you have 10+ employees, we can likely help.
            </div>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-4">
          <AccordionTrigger>
            <div className="faq-question">
              <MessageSquare size={22} className="faq-icon" />
              <span>What's the catch with transparent pricing?</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="faq-answer">
              There is no catch. We believe you deserve to know exactly what you're paying for. Our itemized pricing shows every component like payroll processing, benefits administration, and compliance support with no hidden platform fees or surprise add-ons. Most clients save 15% to 40% compared to big box PEOs because we eliminate the hidden costs.
            </div>
          </AccordionContent>
        </AccordionItem>
        <AccordionItem value="item-5">
          <AccordionTrigger>
            <div className="faq-question">
              <MessageSquare size={22} className="faq-icon" />
              <span>What happens at renewal?</span>
            </div>
          </AccordionTrigger>
          <AccordionContent>
            <div className="faq-answer">
              Amplify does all the diligence. We shop our full suite of carriers and products to find the solution that best meets our clients needs. We aren't captive to a single carrier or option, so we truly act as a consultant.
            </div>
          </AccordionContent>
        </AccordionItem>
      </Accordion>
    </div>
  </section>
);

export default FAQSection;
